// extracted by mini-css-extract-plugin
export default {"SignInSignUpLogo":"SiderContentC_SignInSignUpLogo__ctlpY","Menu":"SiderContentC_Menu__wJhci"};